import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as projectActions from "../../actions/projectActions";
import * as customerActions from "../../actions/customerActions";
import * as contractActions from "../../actions/contractActions";
import * as departmentActions from "../../actions/departmentActions";

import * as codeActions from "../../actions/codeActions";
import * as userActions from "../../actions/userActions";

import HeaderWrapper from "../common/HeaderWrapper";
import ProjectForm from "./ProjectForm";

class ProjectAddPage extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount = async () => {
    const { customers, users, departments, actions } = this.props;
    this.setState({ loading: true });
    if (!customers.length) await actions.loadCustomers();
    if (!departments.length) await actions.loadDepartments();
    if (!users.length) await actions.loadUsers();
  };

  handleAdd = (project) => {
    this.props.actions.createProject(project);
  };

  handleCancel = () => {
    this.props.history.push("/app/projects");
  };

  render() {
    const { customers, departments, users, contracts, codes } = this.props;

    return (
      <React.Fragment>
        <HeaderWrapper breadcrumbs={[{ label: "Add Project" }]} />
        <div className="content-wrapper">
          <ProjectForm
            project={{}}
            customers={customers}
            codes={codes}
            departments={departments}
            contracts={contracts}
            users={users}
            onCancel={this.handleCancel}
            onAdd={this.handleAdd}
            saving={this.props.savingProject}
            editing
            adding
          />
        </div>
      </React.Fragment>
    );
  }
}

ProjectAddPage.propTypes = {
  actions: PropTypes.object.isRequired,
  savingProject: PropTypes.bool,
  customers: PropTypes.array,
  contracts: PropTypes.array,
  departments: PropTypes.array,
  users: PropTypes.array,
  codes: PropTypes.array,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    savingProject: state.reducers.savingProject,
    customers: state.reducers.customers,
    contracts: state.reducers.contracts,
    departments: state.reducers.departments,
    users: state.reducers.users,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...projectActions,
        ...customerActions,
        ...contractActions,
        ...departmentActions,
        ...userActions,
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ProjectAddPage);
